import { render, staticRenderFns } from "./ovenreportdetail.vue?vue&type=template&id=5042e727&"
import script from "./ovenreportdetail.vue?vue&type=script&lang=js&"
export * from "./ovenreportdetail.vue?vue&type=script&lang=js&"
import style0 from "./ovenreportdetail.vue?vue&type=style&index=0&id=5042e727&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports